<template>
  <div class="clientes">
    <h1 class="titulo-card fs-4">Servidores</h1>
    <div class="form-group card-principal">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-link" id="nav-bng-tab" data-bs-toggle="tab" href="#nav-bng" role="tab" aria-controls="nav-bng" aria-selected="true">
            <font-awesome-icon :icon="['fas', 'wifi']" fixed-width class="me-1"/>
            BNG's
          </a>
          <a class="nav-link active" id="nav-olt-tab" data-bs-toggle="tab" href="#nav-olt" role="tab" aria-controls="nav-olt" aria-selected="true">
            <font-awesome-icon :icon="['fas', 'server']" fixed-width class="me-1"/>
            OLT's
          </a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <!-- bng's -->
        <div class="tab-pane fade show" id="nav-bng" role="tabpanel" aria-labelledby="nav-bng-tab">
          <ServidoresBNG/>
        </div>
        <!-- bng's -->

        <!-- olt's -->
        <div class="tab-pane fade show active" id="nav-olt" role="tabpanel" aria-labelledby="nav-olt-tab">
          <ServidoresOLT/>
        </div>
        <!-- olt's -->

        <!-- contatos -->
        <div class="tab-pane fade" id="nav-contatos" role="tabpanel" aria-labelledby="nav-contatos-tab">
        </div>
        <!-- contatos -->

        <!-- endereços -->
        <div class="tab-pane fade" id="nav-enderecos" role="tabpanel" aria-labelledby="nav-enderecos-tab">
        </div>
        <!-- endereços -->
      </div>
    </div>
  </div>
</template>

<script>
import ServidoresBNG from '@/views/ServidoresBNG.vue'
import ServidoresOLT from '@/views/ServidoresOLT.vue'

export default {
  name: 'Servidores',
  components: {
    ServidoresBNG,
    ServidoresOLT,
  },
  data() {
    return {}
  },
}
</script>
